export default {
  router: [
    {
      exact: true,
      path: '/CarrierManagement/mapArrangedRoute',
      cacheKey: '/CarrierManagement/mapArrangedRoute',
      isNoCache: true,
      title: '每日排线核查',
    },
  ],
  title: '每日排线核查',
};
